import { API_BASE_URL, DEFAULT_HEADERS } from '../../apiConfig';

const GRAPH_PROMPT_ENDPOINTS = ['/api/prompts/generate-from-graph', '/api/prompt-graph'];
const STANDARD_PROMPT_ENDPOINTS = ['/api/prompts/generate'];

export const PromptGenerationService = {
  async generatePrompt({
    userId,
    type = 'project',
    generationMode = 'implementation',
    context = {},
    input = {},
    sourcePrompts = [],
    snapshots = {},
  }) {
    const requestBody = {
      userId,
      type,
      generationMode,
      context,
      input,
      sourcePrompts,
      snapshots,
    };

    const hasSourcePrompts = Array.isArray(sourcePrompts) && sourcePrompts.length > 0;
    const candidateEndpoints = hasSourcePrompts
      ? [...GRAPH_PROMPT_ENDPOINTS, ...STANDARD_PROMPT_ENDPOINTS]
      : [...STANDARD_PROMPT_ENDPOINTS];

    let lastError = null;

    for (const endpoint of candidateEndpoints) {
      try {
        const response = await fetch(`${API_BASE_URL}${endpoint}`, {
          method: 'POST',
          headers: DEFAULT_HEADERS,
          body: JSON.stringify(requestBody),
        });

        const data = await response.json().catch(() => ({}));

        if (response.ok) {
          return data;
        }

        const message =
          data.error || data.message || `Failed to generate prompt: ${response.statusText}`;

        if (![404, 405].includes(response.status)) {
          throw new Error(message);
        }

        lastError = new Error(message);
      } catch (error) {
        lastError = error instanceof Error ? error : new Error('Failed to generate prompt');
      }
    }

    throw lastError || new Error('Failed to generate prompt');
  },
};
